import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../../Components/Navigation';
import ButtonNext from '../../Components/ButtonNext';
import PhoneInput from 'react-phone-number-input/input'
// import { database } from '../../Firebase'
// import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import AppHeaderLogo from '../../Images/app-header_logo_2x.png';

const PhoneNumberForWaiting = ( {phoneNumber, setPhoneNumber, LOCAL_STORAGE_KEY_PHONE_NUMBER} ) => {
  const [buttonDisabled, setButtonDisable] = useState(true)
  const [timeoutTrigger, setTimeoutTrigger] = useState(false)
  const [submitPressed, setSubmitPressed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [error, setError] = useState(false)
  const navigate = useNavigate();
  const linkBack = ""
  const linkSkip = ""
  const phoneNumberStyle = { //Den här css ska över i css-fil. OBS: Den här behövs för att det inte ska bli lagg i css-laddning
    border: 'none',
    padding: '10px 10px 10px 10px',
    fontSize: '20px',
    fontFamily: 'Montserrat',
    textAlign: 'center',
    borderRadius: '40px',
    color: "#000",
    backgroundColor: "#fff"
  }
  const signUpWaitingListUrl = process.env.REACT_APP_CLOUD_FUNCTION_API_SIGNUPWAITINGLIST

  //Generate error message when upload takes to long
  // useEffect(() => {
  //   if (!submitPressed) return
  //   const timer = setTimeout(() => {
  //     setErrorMessage("Kontrollera uppkopplingen.")
  //     setError(true)
  //   }, 5000);
  //   return () => {
  //     clearTimeout(timer);
  //   }
  // }, [timeoutTrigger, submitPressed])

  const handleSaveToFirestore = async () => {
    try {
      const response = await fetch(signUpWaitingListUrl,{
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          signUpPhoneNumber: phoneNumber
        }),
      })
      const savedSuccessfully = await response.json()
      if (savedSuccessfully) {
        setIsLoading(false)
        navigate("../confirmed-waiting") //Then navigate to next page
      } else {
        setIsLoading(false)
        setErrorMessage("Något gick fel. Försök igen.")
        setError(true)
      }      
    } catch (e) {
      setIsLoading(false)
      setErrorMessage("Något gick fel. Försök igen.")
      setError(true)
    }
  }

  const handleSubmit = async (event) =>{
    event.preventDefault()
    setError(false)
    setIsLoading(true)
    //Ensure error message is visible if upload takes to long
    setSubmitPressed(true)
    setTimeoutTrigger(current => !current)
    await handleSaveToFirestore()
    localStorage.setItem(LOCAL_STORAGE_KEY_PHONE_NUMBER, JSON.stringify(phoneNumber)) //Save phone number to local storage on submit
  }

  useEffect(() => {
    if (phoneNumber === undefined) {
      setButtonDisable(true)
    } else {
      if (phoneNumber.length < 12 ) {
        setButtonDisable(true)
      } else {
        setButtonDisable(false)
      }
    }      
  }, [phoneNumber])

  const openUserAgreement = () => {
    window.open('https://houtive.com/anvandarvillkor', '_blank', 'noopener,noreferrer');
  };

  const openIntegrityPolicy = () => {
    window.open('https://houtive.com/integritetspolicy', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='flex flex-1 h-[calc(100dvh)] flex-col items-center justify-center bg-[#000]'>
      {/* Upper section */}
      <div className='flex flex-1 justify-between flex-col'>
        <div className='mt-3'>
          <img src={AppHeaderLogo} className='max-w-[100px]'/>
          {/* <h2 className='text-xl text-center text-[#fff]'>
            houtive
          </h2> */}
        </div>
        <Navigation
          linkBack={linkBack}
          linkSkip={linkSkip}
          showLinkBack={false} 
          showLinkSkip={false}
        />
      </div>
      {/* Middle section */}
      <div className="flex flex-1 justify-center flex-col w-full max-w-[420px] px-6">
        <div className="text-center mb-4">
          <p className="text-sm text-[#606060]">Väntelista</p>
          {/* <p className="text-sm text-[#606060]">Steg 2 av 2</p> */}
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-center leading-tight text-white mb-2">
          Ange ditt telefonnummer
        </h2>
        <p className="text-center text-sm sm:text-base text-[#D6D6D6] leading-relaxed mb-4">
          Används för inloggning.
        </p>

        <div className='flex justify-center'>
          <PhoneInput
            country="SE"
            style={phoneNumberStyle}
            placeholder={"07xxxxxxxx"}
            value={phoneNumber}
            onChange={setPhoneNumber} />
        </div>
      </div>
        
        <div className="w-full flex flex-1 flex-col justify-center items-center max-w-[420px] px-6 mb-10">
        {/* {error && <div>{errorMessage}</div>} */}
          <ButtonNext
            handleSubmit={handleSubmit}
            buttonDisabled={buttonDisabled}
            isLoading={isLoading}
            error={error}
            errorMessage={errorMessage}
            buttonText={"Skriv upp på väntelista"}
          />
          <p className="mt-3 text-center text-xs text-[#D6D6D6]">
            Genom att fortsätta godkänner du Houtives{" "}
            <button
              type="button"
              onClick={openUserAgreement}
              className="text-[#9D4EDD] underline decoration-dotted underline-offset-2"
            >
              användarvillkor
            </button>{" "}
            och{" "}
            <button
              type="button"
              onClick={openIntegrityPolicy}
              className="text-[#9D4EDD] underline decoration-dotted underline-offset-2"
            >
              integritetspolicy
            </button>
            .
          </p>          
        </div>
    </div>
  );
}

export default PhoneNumberForWaiting;
